import * as React from "react";
import {InjectedIntlProps, injectIntl} from "react-intl";
// import { FormattedMessage } from "react-intl";
import {Link} from "react-router-dom";
import { tooltips } from "src/constants/profileSettings";
import Profile from "src/models/Profile";
import { Log, logAction, logType } from 'src/utils/api';
import {shortenTo} from "src/utils/stringManipulation";
import StandardImage from "../../../../../assets/cards/standard.png";
import GeneratorEntity from "../../../../../models/Generator";
import translations from "./../../translations";

interface IProps extends InjectedIntlProps {
  generator: GeneratorEntity;
  showDragUi: boolean;

  delete: (generator: GeneratorEntity) => void;
  run: (generator: GeneratorEntity) => void;
  validator: (generator: GeneratorEntity) => void;
  profile: Profile
  download: (gen: GeneratorEntity) => void;
  openTokenModalForGenerator: (gen: GeneratorEntity) => void;
}

const dragStyle =  {opacity: 0.2, background: "#7f8c8d", padding: "1.25em"}
const noDrag =  {padding: "1.25em"}

const GeneratorCard: React.SFC<IProps> = props => {
  const obj = {};

  function importAllImages() {
    const context = (require as any).context("../../../../../assets/cards", true);

    context.keys().forEach((key: any) => {
      const countryCode = key
        .split("./")
        .pop() // remove the first 2 characters
        .substring(0, key.length - 6); // remove the file extension
      obj[countryCode] = context(key);
    });

    // return obj;
  }

  const getCategories: any = (categories: any) => {
    let categoryList: string = "";
    let categoryCount = 0;
    if (categories !== undefined && categories !== null && categories.length > 0) {
      for (const category of categories) {
        categoryCount++;
        categoryList = categoryList + '<span class="tag is-dark">' + shortenTo(category, 16) + " </span> ";
        if (categoryCount === 5) {
          categoryList = categoryList + '<span class="tag is-dark">...</span>';
          break;
        }
      }
      categoryList = categoryList.substring(0, categoryList.length - 2);
    }

    return categoryList;
  };

  const deleteMe = () => {
    props.delete(props.generator);
    Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Pressed the Delete button!");
  };

  const findImage: any = (categories: any) => {
    if (categories !== null && categories.length > 0) {
      // We've got categories!
      importAllImages();
      const imageList = Object.keys(obj);
      // We've got all images!
      const genName: string = props.generator.name;
      const genExplanation: any = props.generator.explanation;

      for (const img of imageList) {
        if (genName.toLowerCase().search(img.toLowerCase()) !== -1) {
          return obj[img];
        }
      }

      for (const category of categories) {
        for (const img of imageList) {
          if (category.toLowerCase().indexOf(img.toLowerCase()) !== -1) {
            return obj[img];
          }
        }
      }
      if (genExplanation !== null && genExplanation !== undefined) {
        for (const img of imageList) {
          if (genExplanation.toLowerCase().search(img.toLowerCase()) !== -1) {
            return obj[img];
          }
        }
      }
      return StandardImage;
    }
    return StandardImage;
  };

  const run = () => {
    props.run(props.generator);
    Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Pressed the Run button!")
  };

  const handleDownload = () => {
    props.download(props.generator);
    Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Pressed the Download button!")
  }

  const openTokenModal = () => {
    props.openTokenModalForGenerator(props.generator);
  }

  return (
    <div className={"column is-12-tablet is-6-desktop is-4-widescreen"}>
      <article className="box" style={props.showDragUi ? dragStyle: noDrag}>
        <div className="title is-5" style={{marginBottom: "0.5em"}}>
          <Link to={"/edit/" + props.generator.id} onClick={() => { Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Clicked on the Title!")}}>{shortenTo(props.generator.name, 90)}</Link>{/* tslint:disable-line */}
        </div>
        <div className="media">
          <div className="media-left">
          <Link to={"/edit/" + props.generator.id} onClick={() => { Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Pressed the Edit button!")}} ><img src={findImage(props.generator.categories)} width="95px" height="96px" /></Link> {/* tslint:disable-line */}
          </div>
          <div className="media-content">
            <div className="content is-small" style={{overflowX: "hidden"}}>
              {props.generator.explanation !== undefined && props.generator.explanation !== null ? shortenTo(props.generator.explanation, 150) : props.intl.formatMessage(translations.noDescription)}
            </div>
            <div>
              <p className="subtitle" style={{marginBottom: "0.5em"}}>
                <span dangerouslySetInnerHTML={{__html: getCategories(props.generator.categories)}} />
              </p>
            </div>
            <div style={{marginTop: "0.5em"}}>
              <a onClick={run} className={props.profile.showTooltips ===  tooltips.on ? "tooltip is-tooltip-bottom" : ''}  data-tooltip={props.intl.formatMessage(translations.run)}>
                <span className="icon fa-lg" style={{marginRight: "0.5em"}}>
                  <i className="fa fa-play" />
                </span>
              </a>
              <Link to={"/edit/" + props.generator.id} onClick={() => { Log(logType.action, logAction.clickHandler, "GeneratorCard" , "Pressed the Edit button!")}} className={props.profile.showTooltips ===  tooltips.on ? "tooltip is-tooltip-bottom" : ''} data-tooltip={props.intl.formatMessage(translations.edit)}> {/* tslint:disable-line */}
                <span className="icon fa-lg">
                  <i className="fa fa-edit" />
                </span>
              </Link>
              <a onClick={handleDownload} className={props.profile.showTooltips ===  tooltips.on ? "tooltip is-tooltip-bottom" : ''}  data-tooltip={props.intl.formatMessage(translations.downloadTooltip)}> 
                <span className="icon fa-lg" style={{marginRight: "0.5em"}}>
                <i className="fas fa-download" />
                </span>
              </a>
              <a onClick={openTokenModal} className={props.profile.showTooltips ===  tooltips.on ? "tooltip is-tooltip-bottom" : ''}  data-tooltip="Manage Public Tokens"> 
                <span className="icon fa-lg" style={{marginRight: "0.5em"}}>
                <i className="fas fa-share-square" />
                </span>
              </a>

              <a onClick={deleteMe} className={props.profile.showTooltips ===  tooltips.on ? "is-pulled-right tooltip is-tooltip-bottom" : "is-pulled-right"} data-tooltip={props.intl.formatMessage(translations.delete)}>
                <span className="icon fa-lg">
                  <i className="fal fa-trash-alt" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};

export default injectIntl(GeneratorCard);



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorView/CardView/GeneratorCard.tsx